// Reuse the product line cart integration and grid expansion on all screen sizes.
customElements.whenDefined('liene-product-line').then(() => {
  if (customElements.get('liene-accessories-carousel')) return;
  const ProductLine = customElements.get('liene-product-line');
  customElements.define('liene-accessories-carousel', class extends ProductLine {
    connectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('.lac__track');
      this.previous = this.querySelector('[data-direction="-1"]');
      this.next = this.querySelector('[data-direction="1"]');
      if (!this.track || !this.previous || !this.next) return;
      this.cards = [...this.querySelectorAll('.lpg__card')];
      this.entries = [...this.track.children];
      this.more = this.querySelector('.lac__more');
      this.desktop = matchMedia('(min-width: 750px)');
      this.expanded = false;
      this.desktop.addEventListener('change', () => {
        this.setExpanded(this.expanded);
        this.track.scrollLeft = 0;
        this.update();
      }, options);
      this.setExpanded(false);
      this.cards.forEach(card => { card.product = JSON.parse(card.dataset.initial); });
      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= max - 2;
      };
      this.move = direction => {
        const first = this.track.firstElementChild;
        if (!first) return;
        const styles = getComputedStyle(this.track);
        const step = first.getBoundingClientRect().width + (parseFloat(styles.columnGap) || 0);
        const rtl = styles.direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({ left: direction * step * rtl, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.addEventListener('click', event => {
        const add = event.target.closest('[data-add]');
        const arrow = event.target.closest('[data-direction]');
        if (event.target.closest('.lac__more')) {
          this.setExpanded(!this.expanded);
          if (!this.expanded && this.more.getBoundingClientRect().top < 0) {
            this.more.scrollIntoView({ block: 'nearest', behavior: 'instant' });
          }
        }
        if (add) this.addToCart(add);
        if (arrow) this.move(Number(arrow.dataset.direction));
      }, options);
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        if (this.dataset.displayMode === 'grid') return;
        event.preventDefault();
        const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
        this.move((event.key === 'ArrowRight' ? 1 : -1) * rtl);
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.lpg__card, .lac__empty');
        if (!card) return;
        if (this.dataset.displayMode === 'grid') {
          if (card.hidden) this.setExpanded(true);
          card.scrollIntoView({ block: 'nearest', behavior: 'instant' });
          return;
        }
        const styles = getComputedStyle(this.track);
        const rect = card.getBoundingClientRect(), trackRect = this.track.getBoundingClientRect();
        const padding = parseFloat(styles.scrollPaddingInlineStart) || 0;
        const delta = styles.direction === 'rtl' ? rect.right - trackRect.right + padding : rect.left - trackRect.left - padding;
        this.track.scrollBy({ left: delta, behavior: 'instant' });
      }, options);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      [...this.track.children].forEach(card => this.observer.observe(card));
      this.update();
    }
    setExpanded(expanded) {
      this.expanded = expanded;
      const grid = this.dataset.displayMode === 'grid';
      this.entries.forEach((card, index) => { card.hidden = grid && !expanded && index >= 4; });
      if (!this.more) return;
      this.more.hidden = !grid || this.entries.length <= 4;
      this.more.setAttribute('aria-expanded', String(expanded));
      this.more.querySelector('[data-more]').hidden = expanded;
      this.more.querySelector('[data-less]').hidden = !expanded;
    }
    disconnectedCallback() { super.disconnectedCallback(); this.observer?.disconnect(); }
  });
});
